import { useParams } from 'react-router-dom';

import FormData from './FormData';

import LayoutContent from '@/layout/Content';

const AddCategory = () => {
    const { id } = useParams();
    const title = id ? 'CẬP NHẬT' : 'THÊM MỚI';
    return (
        <LayoutContent className="p-add-floor" title={`LOẠI PHÒNG / ${title}`} isBack>
            <div className="p-add-floor__form">
                <FormData />
            </div>
        </LayoutContent>
    );
};

export default AddCategory;
